
export class Element {

    Element_ID: number;
    ElementArea_ID: number;
    ElementAreaName: string;
    ElementSubAreaName: string;
    ElementSubAreas: string[] = [];
    ElementName: string;
    ControlName: string;
    XPath: string;
    ParameterName: string;
    ParameterValue: string;
    Action: string;
    Actions: string[] = [];
}

export class ElementAction {
    Element: Element;
    Action: string;
}

export enum AutomatedTestStatus {
    InProgress = 0,
    ReadyForReview = 1,
    Approved = 2,
    IsObsolete = 3
}

export class AutomatedTest {
    Test_ID: number;
    TestArea_ID: number;
    TestAreaName: string;
    TestSubAreaName: string;
    TestName: string;
    TestOrder: number;
    InProgress: boolean;
    ReadyForReview: boolean;
    Approved: boolean;
    IsObsolete: boolean;
    IsSubTestOnly: boolean;
    IsInsertedStep = false;
    SubTestElement_ID: number;
    Parameter: AutomatedTestParameter;
    SelectedStatus: AutomatedTestStatus;
    SelectedStatusDescription: string;
    Comments: string;
    CopyTestId: number;
}

export class AutomatedTestStep {
    Test_ID: number;
    TestArea_ID: number;
    TestAreaName: string;
    TestSubAreaName: string;
    TestName: string;
    TestOrder: number;
    InProgress: boolean;
    ReadyForReview: boolean;
    Approved: boolean;
    IsSubTestOnly: boolean;
    Step_ID: number;
    StepName: string;
    StepOrder: number;
    Elements: Element[] = [];
    Element: Element;
    Element_ID: number;
    ElementArea_ID: number;
    ElementAreaName: string;
    ElementSubAreaName: string;
    ElementSubAreas: string[] = [];
    ElementName: string;
    PageTitle: string;
    XPath: string;
    ControlName: string;
    Action_ID: number;
    ActionName = '';
    Parameter_ID: number;
    ParameterName: string;
    ParameterValue: string;
    InnerTest_ID: number;
    InnerTestName: string;
    Comments: string;
}

export class AutomatedTestArea {
    Area_ID: number;
    AreaName: string;
    SubAreaName: string;
}

export class AutomatedTestParameter {
    ID: number;
    ParameterName: string;
    ParameterValue: string;
    Test_ID: number;
}

export class SubTestDependentTest {
    Area_ID: number;
    AreaName: string;
    SubAreaName: string;
    Test_ID: number;
    TestName: string;
    StepOrder: number;
}

export class AutomatedTestStepQuickView {
    Test_ID: number;
    TestArea_ID: number;
    TestAreaName: string;
    TestSubAreaName: string;
    TestName: string;
    TestOrder: number;
    InProgress: boolean;
    ReadyForReview: boolean;
    Approved: boolean;
    IsSubTestOnly: boolean;
    Step_ID: number;
    StepName: string;
    StepOrder: number;
    Elements: Element[] = [];
    Element: Element;
    Element_ID: number;
    ElementArea_ID: number;
    ElementAreaName: string;
    ElementSubAreaName: string;
    ElementName: string;
    PageTitle: string;
    XPath: string;
    ControlName: string;
    Action_ID: number;
    ActionName = '';
    Parameter_ID: number;
    ParameterName: string;
    ParameterValue: string;
    InnerTest_ID: number;
    InnerTestName: string;
    TestComments: string;
    StepComments: string;
}



